import { ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER } from '@/lib/constants/securityRoles'

export const loginRoute = {
  name: 'LOGIN',
  path: '/login',
  url: '/login'
}

export const logoutRoute = {
  name: 'LOGOUT',
  path: '/logout',
  url: '/logout',
  roles: [ ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER ]
}

export const notAuthorizedRoute = {
  name: 'NOT_AUTHORIZED',
  path: '/notAuthorized',
  url: '/notAuthorized'
}

export const defaultRoute = {
  name: 'DEFAULT',
  path: '/',
  url: '/',
  roles: [ ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER ]
}

export const forgotPasswordRoute = {
  name: 'FORGOT_PASSWORD',
  path: '/forgotPassword',
  url: '/forgotPassword'
}

export const resetPasswordRoute = {
  name: 'RESET_PASSWORD',
  path: '/resetPassword/:token',
  url: '/resetPassword'
}

export const usersRoute = {
  name: 'USERS',
  path: '/users',
  url: '/users',
  roles: [ ADMIN ]
}

export const userCreateRoute = {
  name: 'USERS_CREATE',
  path: '/users/new',
  url: '/users/new',
  roles: [ ADMIN ]
}

export const userEditRoute = {
  name: 'USERS_EDIT',
  url: '/users/edit',
  path: '/users/:id/edit',
  roles: [ ADMIN ]
}

export const userPasswordEditRoute = {
  name: 'USER_PASSWORDS_EDIT',
  url: '/users/editPassword',
  path: '/users/:id/editPassword/:returnRoute',
  roles: [ ADMIN ]
}

export const staffRoute = {
  name: 'STAFF',
  url: '/staff',
  path: '/staff',
  roles: [ ADMIN ]
}

export const staffCreateRoute = {
  name: 'STAFF_CREATE',
  path: '/staff/new',
  url: '/staff/new',
  roles: [ ADMIN ]
}

export const staffEditRoute = {
  name: 'STAFF_EDIT',
  url: '/staff/edit',
  path: '/staff/:id/edit',
  roles: [ ADMIN ]
}

export const clientsRoute = {
  name: 'CLIENTS',
  path: '/clients',
  url: '/clients',
  roles: [ ADMIN, RECRUITER, SALES_PERSON, MANAGER ]
}

export const clientCreateRoute = {
  name: 'CLIENTS_CREATE',
  path: '/clients/new',
  url: '/clients/new',
  roles: [ ADMIN, SALES_PERSON, MANAGER ]
}

export const clientEditRoute = {
  name: 'CLIENTS_EDIT',
  path: '/clients/:id/edit',
  url: '/clients/edit',
  roles: [ ADMIN, RECRUITER, SALES_PERSON, MANAGER ],
  alignTop: true
}

export const businessEntitiesRoute = {
  name: 'BUSINESS_ENTITIES',
  path: '/businessEntities',
  url: '/businessEntities',
  roles: [ ADMIN ]
}

export const businessEntityCreateRoute = {
  name: 'BUSINESS_ENTITIES_CREATE',
  path: '/businessEntities/new',
  url: '/businessEntities/new',
  roles: [ ADMIN ]
}

export const businessEntityEditRoute = {
  name: 'BUSINESS_ENTITIES_EDIT',
  path: '/businessEntities/:id/edit',
  url: '/businessEntities/edit',
  roles: [ ADMIN ]
}

export const assignmentsRoute = {
  name: 'ASSIGNMENTS',
  path: '/assignments',
  url: '/assignments',
  roles: [ ADMIN, SALES_PERSON, RECRUITER, MANAGER ]
}

export const assignmentCreateRoute = {
  name: 'ASSIGNMENTS_CREATE',
  path: '/assignments/new',
  url: '/assignments/new',
  roles: [ ADMIN, MANAGER ]
}

export const assignmentEditRoute = {
  name: 'ASSIGNMENTS_EDIT',
  path: '/assignments/:id/edit',
  url: '/assignments/edit',
  roles: [ ADMIN, MANAGER, RECRUITER, SALES_PERSON ]
}

export const consultantTimeSheetRoute = {
  name: 'TIMESHEET',
  path: '/timesheet',
  url: '/timesheet',
  roles: [ CONSULTANT ]
}

export const timeCardReportRoute = {
  name: 'TIME_CARD_REPORT',
  url: '/timeCardReport',
  path: '/timeCardReport',
  roles: [ ADMIN, RECRUITER, SALES_PERSON, MANAGER ]
}

export const myProfileRoute = {
  name: 'MY_PROFILE',
  path: '/myprofile',
  url: '/myprofile',
  roles: [ ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER ]
}

export const directPlacementsRoute = {
  name: 'DIRECT_PLACEMENTS',
  path: '/directPlacements',
  url: '/directPlacements',
  roles: [ ADMIN, SALES_PERSON, RECRUITER, MANAGER ]
}

export const directPlacementCreateRoute = {
  name: 'DIRECT_PLACEMENTS_CREATE',
  path: '/directPlacements/new',
  url: '/directPlacements/new',
  roles: [ ADMIN, SALES_PERSON, MANAGER ]
}

export const directPlacementEditRoute = {
  name: 'DIRECT_PLACEMENTS_EDIT',
  url: '/directPlacements/edit',
  path: '/directPlacements/:id/edit',
  roles: [ ADMIN, SALES_PERSON, RECRUITER, MANAGER ]
}

export const commissionReportRoute = {
  name: 'COMMISSION_REPORT',
  path: '/commissionReport',
  url: '/commissionReport',
  roles: [ ADMIN, MANAGER ]
}

export const commissionDetailsReportRoute = {
  name: 'COMMISSION_DETAIL_REPORT',
  path: '/commissionDetailReport',
  url: '/commissionDetailReport',
  roles: [ ADMIN, MANAGER, SALES_PERSON, RECRUITER ]
}

export const invoiceReportRoute = {
  name: 'INVOICE_REPORT',
  path: '/invoicingReport',
  url: '/invoicingReport',
  roles: [ ADMIN, MANAGER ]
}

export const payrollReportRoute = {
  name: 'PAYROLL_REPORT',
  path: '/payrollReport',
  url: '/payrollReport',
  roles: [ ADMIN ]
}

export const projectsGPReportRoute = {
  name: 'PROJECTS_GP_REPORT',
  path: '/projectsGPReport',
  url: '/projectsGPReport',
  roles: [ ADMIN ]
}

export const gpToCostReportRoute = {
  name: 'GP_TO_COST_REPORT',
  path: '/gpToCost',
  url: '/gpToCost',
  roles: [ ADMIN, MANAGER ]
}

export const dashboardRoute = {
  name: 'ADMIN_DASHBOARD_ROUTE',
  path: '/dashboard',
  url: '/dashboard',
  roles: [ ADMIN, MANAGER, RECRUITER, SALES_PERSON, CONSULTANT ]
}

export const dealsRoute = {
  name: 'DEALS',
  path: '/deals',
  url: '/deals',
  roles: [ ADMIN, MANAGER, SALES_PERSON, RECRUITER ]
}

export const dealWizardRoute = {
  name: 'DEAL_WIZARD',
  path: '/deals/wizard/:id?/:step?/edit',
  url: '/deals/wizard',
  roles: [ ADMIN, MANAGER, SALES_PERSON, RECRUITER ]
}

export const teamsRoute = {
  name: 'TEAMSROUTE',
  path: '/teams',
  url: '/teams',
  roles: [ ADMIN ]
}

export const projectsRoute = {
  name: 'PROJECTSROUTE',
  path: '/projects',
  url: '/projects',
  roles: [ ADMIN ]
}

export const projectCreateRoute = {
  name: 'PROJECTS_CREATE',
  path: '/projects/new',
  url: '/projects/new',
  roles: [ ADMIN ]
}

export const projectEditRoute = {
  name: 'PROJECTS_EDIT',
  path: '/projects/:id/edit',
  url: '/projects/edit',
  roles: [ ADMIN ]
}

export const settingsRoute = {
  name: 'SETTINGSROUTE',
  path: '/settings',
  url: '/settings',
  roles: [ ADMIN ]
}

export const placementGoalsRoute = {
  name: 'PLACEMENTGOALSROUTE',
  path: '/placementGoals',
  url: '/placementGoals',
  roles: [ ADMIN, MANAGER ]
}

export const directPlacementGoalsRoute = {
  name: 'DIRECTPLACEMENTGOALSROUTE',
  path: '/directPlacementGoals',
  url: '/directPlacementGoals',
  roles: [ ADMIN, MANAGER ]
}

export const revenueDataRoute = {
  name: 'REVENUEDATAROUTE',
  path: '/revenue',
  url: '/revenue',
  roles: [ ADMIN ]
}

export const clockLogsRoute = {
  name: 'CLOCKINCLOCKOUTLOGSROUTE',
  path: '/clockLogs',
  url: '/clockLogs',
  roles: [ CONSULTANT ]
}

export const clockLogsReportRoute = {
  name: 'CLOCKINCLOCKOUTLOGSREPORTROUTE',
  path: '/clockLogsReport',
  url: '/clockLogsReport',
  roles: [ ADMIN ]
}

export const timeManagementRoute = {
  name: 'TIMEMANAGEMENTROUTE',
  path: '/timeManagement',
  url: '/timeManagement',
  roles: [ ADMIN, SALES_PERSON ]
}

export const workflowTemplatesRoute = {
  name: 'WORKFLOW_TEMPLATES',
  path: '/workflowTemplates',
  url: '/workflowTemplates',
  roles: [ ADMIN ]
}

export const workflowTemplateCreateRoute = {
  name: 'WORKFLOW_TEMPLATES_CREATE',
  path: '/workflowTemplates/new',
  url: '/workflowTemplates/new',
  roles: [ ADMIN ]
}

export const workflowTemplateEditRoute = {
  name: 'WORKFLOW_TEMPLATES_EDIT',
  path: '/workflowTemplates/:id/edit',
  url: '/workflowTemplates/edit',
  roles: [ ADMIN ]
}

export const workflowInstancesRoute = {
  name: 'WORKFLOW_INSTANCES',
  path: '/workflowInstances',
  url: '/workflowInstances',
  roles: [ ADMIN, RECRUITER, MANAGER ]
}

export const workflowInstanceDetailRoute = {
  name: 'WORKFLOW_INSTANCE_DETAIL',
  path: '/workflowInstances/:id',
  url: '/workflowInstances',
  roles: [ ADMIN, CONSULTANT, RECRUITER, MANAGER ]
}

export const importsRoute = {
  name: 'IMPORTS',
  path: '/imports',
  url: '/imports',
  roles: [ ADMIN ]
}

export const importUploadRoute = {
  name: 'IMPORT_UPLOAD',
  path: '/imports/upload',
  url: '/imports/upload',
  roles: [ ADMIN ]
}

export const importRunDetailRoute = {
  name: 'IMPORT_RUN_DETAIL',
  path: '/imports/:id',
  url: '/imports',
  roles: [ ADMIN ]
}

export const quickBooksConnectionsRoute = {
  name: 'QUICKBOOKS_CONNECTIONS',
  path: '/quickbooks/connections',
  url: '/quickbooks/connections',
  roles: [ ADMIN ],
  alignTop: true
}

export const invoicesRoute = {
  name: 'INVOICES',
  path: '/invoices',
  url: '/invoices',
  roles: [ ADMIN ],
  alignTop: true
}

export const invoiceDetailRoute = {
  name: 'INVOICE_DETAIL',
  path: '/invoices/:id',
  url: '/invoices',
  roles: [ ADMIN ],
  alignTop: true
}

export const myWorkflowTasksRoute = {
  name: 'MY_WORKFLOW_TASKS',
  path: '/myWorkflowTasks',
  url: '/myWorkflowTasks',
  roles: [ ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER ]
}

export const workflowDashboardRoute = {
  name: 'WORKFLOW_DASHBOARD',
  path: '/workflowDashboard',
  url: '/workflowDashboard',
  roles: [ ADMIN, RECRUITER, MANAGER ]
}

export const placementsRoute = {
  name: 'PLACEMENTS',
  path: '/placements',
  url: '/placements',
  roles: [ ADMIN, MANAGER, RECRUITER, SALES_PERSON ]
}

export const documentTemplatesRoute = {
  name: 'DOCUMENT_TEMPLATES',
  path: '/documentTemplates',
  url: '/documentTemplates',
  roles: [ ADMIN ]
}

export const documentTemplateCreateRoute = {
  name: 'DOCUMENT_TEMPLATES_CREATE',
  path: '/documentTemplates/new',
  url: '/documentTemplates/new',
  roles: [ ADMIN ]
}

export const documentTemplateEditRoute = {
  name: 'DOCUMENT_TEMPLATES_EDIT',
  path: '/documentTemplates/:id/edit',
  url: '/documentTemplates/edit',
  roles: [ ADMIN ]
}

export const workflowEmailTemplatesRoute = {
  name: 'WORKFLOW_EMAIL_TEMPLATES',
  path: '/workflowEmailTemplates',
  url: '/workflowEmailTemplates',
  roles: [ ADMIN ]
}

export const workflowEmailTemplateCreateRoute = {
  name: 'WORKFLOW_EMAIL_TEMPLATES_CREATE',
  path: '/workflowEmailTemplates/new',
  url: '/workflowEmailTemplates/new',
  roles: [ ADMIN ]
}

export const workflowEmailTemplateEditRoute = {
  name: 'WORKFLOW_EMAIL_TEMPLATES_EDIT',
  path: '/workflowEmailTemplates/:id/edit',
  url: '/workflowEmailTemplates/edit',
  roles: [ ADMIN ]
}

export const workflowLibraryAssetsRoute = {
  name: 'WORKFLOW_LIBRARY_ASSETS',
  path: '/workflowLibraryAssets',
  url: '/workflowLibraryAssets',
  roles: [ ADMIN ]
}

export const workflowEmailReviewQueueRoute = {
  name: 'WORKFLOW_EMAIL_REVIEW_QUEUE',
  path: '/workflowEmailReviewQueue',
  url: '/workflowEmailReviewQueue',
  roles: [ ADMIN, MANAGER ]
}
